import { IconButton } from '@material-ui/core';
import styled from 'styled-components';

export const AddPhoto = styled(IconButton)``;
